<div class="fullcontainer">
  @if (this.error) { <div class="alert alert-danger">{{ this.error }}</div> }
  @if (this.success) { <div class="alert alert-success">{{ this.success }}</div> }
  <div class='sheet'>
    @if (this.loading) {
      <p>Loading…</p>
    } @else if (this.note) {
      <h1 class='header'>
        Picking Slip {{ this.note.pickingNumber }}
        <span class='badge {{ this.statusBadges[this.note.status] }}' style='font-size:0.9rem;vertical-align:middle'>{{ this.statusLabels[this.note.status] }}</span>
      </h1>
      <p>
        <strong>{{ this.note.accountName }}</strong> · Delivery note <a [routerLink]='["/delivery-notes/edit", this.note.id]'>{{ this.note.noteNumber }}</a>
        @if (this.note.requiredDate) { · required {{ this.ukDate(this.note.requiredDate) }} }
        @if (this.note.customerRef) { · ref {{ this.note.customerRef }} }
      </p>
      <button class='btn btn-secondary' type='button' (click)='this.print()'><i class='fas fa-file-pdf'></i> Print picking slip</button>&nbsp;
      @if (this.note.status === 'part_picked' || this.note.status === 'picked') {
        <button class='btn btn-success' type='button' [disabled]='this.busy' (click)='this.despatch()'><i class='fas fa-shipping-fast'></i> Despatch</button>&nbsp;
      }
      <button class='btn btn-danger' type='button' routerLink='/picking-slips'>Back</button>
      <br /><br />

      @if (!this.open) {
        <div class='alert alert-info'>This note is {{ this.statusLabels[this.note.status].toLowerCase() }} – there is nothing to pick.</div>
      } @else if (!this.lines.length) {
        <div class='alert alert-info'>Everything on this note has been picked.</div>
      } @else {
        <p class='text-muted'>The rows start with where the stock is (oldest first). Change them to what you actually picked – another location or batch, split across rows, or less if you are short.</p>
        <table class='table'>
          <thead>
            <th>Product</th>
            <th>To pick</th>
            <th>Picked from</th>
            <th style='width:12rem'>Batch</th>
            <th style='width:8rem'>Qty</th>
            <th></th>
          </thead>
          <tbody>
            @for (line of this.lines; track line.lineId) {
              @for (row of line.rows; track $index; let i = $index; let first = $first) {
                <tr [class.text-danger]='first && this.picked(line) > line.outstanding'>
                  <td>
                    @if (first) {
                      <strong>{{ line.productName }}</strong>&nbsp;<small class='text-muted'>{{ line.sku }}</small>
                      @if (!line.suggestions.length) { <div class='text-danger small'>No stock found for this product</div> }
                    }
                  </td>
                  <td>@if (first) { {{ line.outstanding }} <div class='small text-muted'>picking {{ this.picked(line) }}</div> }</td>
                  <td>
                    <ng-select [(ngModel)]='row.warehouseLocationId' placeholder='Location' [name]='"loc" + line.lineId + "-" + i'>
                      @for (l of this.locations; track l.id) { <ng-option [value]='l.id'>{{ l.label }}</ng-option> }
                    </ng-select>
                  </td>
                  <td><input type='text' class='form-control' [(ngModel)]='row.batchNumber' placeholder='Batch (optional)'></td>
                  <td><input type='number' min='0' step='any' class='form-control' [(ngModel)]='row.qty'></td>
                  <td>
                    @if (first) {
                      <button class='btn btn-secondary btn-sm' type='button' title='Picked from another location too' (click)='this.addRow(line)'><i class='fas fa-plus'></i> Split</button>
                    } @else {
                      <button class='btn btn-danger btn-sm' type='button' (click)='this.removeRow(line, i)'><i class='fas fa-trash'></i></button>
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
        <button class='btn btn-success' type='button' [disabled]='this.busy || !this.anything' (click)='this.confirm()'><i class='fas fa-check'></i> Confirm pick</button>
      }

      @if (this.note.picks?.length) {
        <h2 class='header' style='margin-top:2rem'>Picked so far</h2>
        <table class='table'>
          <thead><th>Product</th><th>Location</th><th>Batch</th><th>Qty</th><th>When</th></thead>
          <tbody>
            @for (k of this.note.picks; track k.id) {
              <tr>
                <td>{{ this.lineName(k.deliveryNoteLineId) }}</td>
                <td>{{ k.locationCode }}</td>
                <td>{{ k.batchNumber || '' }}</td>
                <td>{{ k.qty }}</td>
                <td>{{ k.pickedAt | date:'dd/MM/yyyy HH:mm' }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
  </div>
</div>
